export const perks = [
  {
    id: 1,
    title: 'Real Ownership & High Growth',
    description:
      "From day one, you'll own impactful projects and work on cutting-edge challenges with a team that loves solving hard problems!",
    image: '/images/img_badge_rocket.svg',
  },
  {
    id: 2,
    title: 'Competitive Pay & Full Health Coverage',
    description:
      'Great talent deserves great rewards. We offer competitive salaries, benefits, and 100% health insurance for you and your family, so you’re secure while you grow.',
    image: '/images/img_badge_dollar.svg',
  },
  {
    id: 3,
    title: 'Global Exposure',
    description:
      'Travel to Singapore, Taiwan, Malaysia, the US, Israel, and more for customer pilots, product discovery, and global collaboration opportunities.',
    image: '/images/img_badge_globe.svg',
  },
  {
    id: 4,
    title: 'Learning & Development Budget',
    description:
      'Your growth matters. We support courses, certifications, fitness programs, and personal development initiatives to help you thrive.',
    image: '/images/img_badge_learn.svg',
  },
  {
    id: 5,
    title: 'Team Off-sites & Community',
    description:
      'Work hard, bond harder! From exciting team off-sites (sometimes in new countries!) to board game nights and weekend getaways, we make space for real connections.',
    image: '/images/img_badge_flight.svg',
  },
  {
    id: 6,
    title: 'Hybrid Flexibility',
    description:
      'Enjoy the best of both worlds: a vibrant office culture in Singapore and Bengaluru, plus the flexibility to work remotely when you need it.',
    image: '/images/img_badge_hybrid.svg',
  },
];

export const outingImages = [
  {
    src: '/images/img_about_1.png',
    alt: 'Team outing image 1',
    id: 1,
  },
  {
    src: '/images/img_about_2.png',
    alt: 'Team outing image 2',
    id: 2,
  },
  {
    src: '/images/img_about_3.png',
    alt: 'Team outing image 3',
    id: 3,
  },
  {
    src: '/images/img_about_4.png',
    alt: 'Team outing image 4',
    id: 4,
  },
  {
    src: '/images/img_about_5.png',
    alt: 'Team outing image 5',
    id: 5,
  },
  {
    src: '/images/img_about_6.png',
    alt: 'Team outing image 6',
    id: 6,
  },
  {
    src: '/images/img_about_7.png',
    alt: 'Team outing image 7',
    id: 7,
  },
  {
    src: '/images/img_about_8.png',
    alt: 'Team outing image 8',
    id: 8,
  },
  {
    src: '/images/img_about_9.png',
    alt: 'Team outing image 9',
    id: 9,
  },
  {
    src: '/images/img_about_10.png',
    alt: 'Team outing image 10',
    id: 10,
  },
];
